// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InternalDocument_wrapper__hHFYE.InternalDocument_isViewDetail__2Y3S- .ant-col.ant-form-item-control .ant-col.ant-form-item-control {\n  display: none !important; }\n\n.InternalDocument_wrapper__hHFYE.InternalDocument_isViewDetail__2Y3S- .ant-row.ant-form-item {\n  margin-bottom: 0; }\n\n.InternalDocument_fileList__zfvR9 {\n  display: flex;\n  flex-direction: column; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "InternalDocument_wrapper__hHFYE",
	"isViewDetail": "InternalDocument_isViewDetail__2Y3S-",
	"fileList": "InternalDocument_fileList__zfvR9"
};
module.exports = exports;
